import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DialogCloseButtonProps {
  onClick: () => void;
  className?: string;
}

export function DialogCloseButton({ onClick, className }: DialogCloseButtonProps) {
  return (
    <Button 
      variant="secondary" 
      size="sm"
      className={`rounded-full h-12 w-12 p-0 ${className || ''}`}
      onClick={onClick}
    >
      <X className="h-4 w-4" />
    </Button>
  );
}

